import { CSSProperties } from "react";
import { useGame } from "~/app";
import { Colors } from "~/jsx/theme";
import {
  XCenteredAbsolute,
  XCrossedSwordsSvg,
  XPlayerIcon,
  XPlayerUnits,
} from "../design";

const conflictSize = 230;
const garnisonSize = 100;
const orbitSize = 75;
const conflictTroopSize = 90;
const marginSize = garnisonSize + orbitSize;

const garnisonVectors = [
  [0, 0],
  [1, 0],
  [0, 1],
  [1, 1],
];

export const XConflict = () => {
  const { game } = useGame();
  const { players } = game;

  return (
    <div style={{ marginLeft: marginSize, marginRight: marginSize }}>
      {garnisonVectors.flatMap(([xFactor, yFactor], index) => {
        const playerId = players.at(index)?.id;
        if (!playerId) return;
        const player = game.getPlayer(playerId);
        const {
          garnisonTroops,
          garnisonDreadnought,
          orbitTroops,
          orbitDreadnought,
        } = player;
        const posCss: CSSProperties =
          xFactor > 0
            ? { right: -garnisonSize * 0.9 }
            : { left: -garnisonSize * 0.9 };
        posCss.top = yFactor === 0 ? 0 : conflictSize - garnisonSize;

        return (
          <div
            key={player.id}
            style={{
              ...posCss,
              position: "absolute",
            }}
          >
            <div
              style={{
                ...(xFactor === 1
                  ? { right: -orbitSize }
                  : { left: -orbitSize }),
                ...(yFactor === 1 ? { bottom: 0 } : { top: 0 }),
                backgroundColor: Colors.grey.c3,
                width: orbitSize,
                height: orbitSize,
                borderRadius: 2000,
                position: "absolute",
                border: "solid 1px black",
              }}
            >
              <XCenteredAbsolute>
                <XPlayerIcon
                  width={32}
                  playerId={playerId}
                  style={{ opacity: 0.1 }}
                />
              </XCenteredAbsolute>
              <XCenteredAbsolute>
                <XPlayerUnits
                  width={32}
                  units={orbitTroops.pile}
                  playerId={playerId}
                  type="troop"
                  variant="compact"
                />
                <XPlayerUnits
                  width={32}
                  units={orbitDreadnought.pile}
                  playerId={playerId}
                  type="dreadnought"
                  variant="compact"
                />
              </XCenteredAbsolute>
            </div>
            <div
              style={{
                backgroundColor: Colors.grey.c3,
                width: garnisonSize,
                height: garnisonSize,
                borderRadius: 2000,
                border: "solid 1px black",
              }}
            >
              <XCenteredAbsolute>
                <XPlayerIcon
                  width={64}
                  playerId={playerId}
                  style={{ opacity: 0.1 }}
                />
              </XCenteredAbsolute>
              <XCenteredAbsolute>
                {garnisonTroops.length > 0 && (
                  <XPlayerUnits
                    width={32}
                    units={garnisonTroops.pile}
                    playerId={playerId}
                    type="troop"
                  />
                )}
                {garnisonDreadnought.length > 0 && (
                  <XPlayerUnits
                    width={32}
                    units={garnisonDreadnought.pile}
                    playerId={playerId}
                    type="dreadnought"
                  />
                )}
              </XCenteredAbsolute>
            </div>
          </div>
        );
      })}

      <div
        style={{
          background: "linear-gradient(180deg, #280504 0%, #89342B 100%)",
          borderRadius: 2000,
          width: conflictSize,
          height: conflictSize,
          border: "solid 1px black",
          color: Colors.common.white,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
        }}
      >
        <XCenteredAbsolute>
          <XCrossedSwordsSvg width={120} style={{ opacity: 0.4 }} />
        </XCenteredAbsolute>
        {garnisonVectors.flatMap(([xFactor, yFactor], index) => {
          const playerId = players.at(index)?.id;
          if (!playerId) return;
          const player = game.getPlayer(playerId);
          const { combatTroops, combatDreadnought } = player;
          const offset = conflictTroopSize / 4;
          const posCss: CSSProperties =
            xFactor > 0 ? { right: offset } : { left: offset };
          if (yFactor > 0) {
            posCss.bottom = offset;
          } else {
            posCss.top = offset;
          }
          return (
            <div
              key={playerId}
              style={{
                ...posCss,
                position: "absolute",
                borderRadius: 1000,
                width: conflictTroopSize,
                height: conflictTroopSize,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {combatTroops.length > 0 && (
                <XPlayerUnits
                  width={32}
                  playerId={playerId}
                  units={combatTroops.pile}
                  type="troop"
                />
              )}
              {combatDreadnought.length > 0 && (
                <XPlayerUnits
                  width={32}
                  playerId={playerId}
                  units={combatDreadnought.pile}
                  type="dreadnought"
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
